import { createAsyncCases } from '@core/utils/fetch/create-cases.util';
import { createSlice } from '@reduxjs/toolkit';
import { getCurrentUser, logout, updateUser } from '../services';
import { accountReducer } from './account.reducer';
var initialState = {
    fetch_data: {
        group: '',
        fetch_name: '',
    },
    loading: false,
    status: 0,
    error: null,
    data: null,
};
export var accountSlice = createSlice({
    name: 'responseData',
    initialState: initialState,
    reducers: {
        accountReducer: accountReducer,
    },
    extraReducers: function (builder) {
        createAsyncCases(builder, getCurrentUser, function (state, action) { });
        createAsyncCases(builder, updateUser, function (state, action) { });
        createAsyncCases(builder, logout, function (state, action) { });
    },
});
